import { defaultColumns, defaultSort } from '../../components/processes/supplierOrders/columns';

export default {
  state: {
    supplierOrders: [],
    tableConfig: null,
    loading: false,
    currentPage: 1,
    filterString: null,
    sorting: {
      prop: 'created_at',
      order: 'asc',
    },
  },
  getters: {
    supplierOrders: state => state.supplierOrders,
    tableConfig: state => state.tableConfig,
    loading: state => state.loading,
    sorting: state => state.sorting,
    filterString: state => state.filterString,
    currentPage: state => state.currentPage,
  },
  mutations: {
    setSupplierOrders(state, supplierOrders) {
      state.supplierOrders = supplierOrders;
    },
    setTableConfig(state, config) {
      state.tableConfig = config;
    },
    setSorting(state, sorting) {
      state.sorting = sorting;
    },
    setFilterString(state, filter) {
      state.filterString = filter;
    },
    setCurrentPage(state, currentPage) {
      state.currentPage = currentPage;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    async fetchTableConfig({ commit }) {
      try {
        const setting = await axios.get('api/table-settings/supplier-order-list');
        const tableConfig = {
          id: setting.id || null,
          type: 'supplier-order-list',
          columns: setting.id ? JSON.parse(setting.config).columns : defaultColumns,
          sort: setting.id ? JSON.parse(setting.config).sort : defaultSort,
        };
        commit('setTableConfig', tableConfig);
      } catch (e) {
      }
    },
    async fetchAll({ commit, state, dispatch }, queryString) {
      commit('setLoading', true);
      try {
        if (!state.tableConfig) {
          await dispatch('fetchTableConfig');
        }
        if (queryString) {
          commit('setFilterString', queryString.substr(1));
        } else if (queryString === '') {
          commit('setCurrentPage', 1);
          commit('setFilterString', '');
        } else {
          commit('setFilterString', state.filterString || '');
        }
        const query = `?page=${state.currentPage}&sortby=${state.sorting.prop}&sorttype=${state.sorting.order === 'ascending' ? 'asc' : 'desc'}&comparetype=${state.sorting.compareType || 'string'}&${state.filterString}`;
        const supplierOrders = await axios.get('api/supplier-orders' + (query || ''));
        commit('setSupplierOrders', supplierOrders);
      } catch (e) {
      }
      commit('setLoading', false);
    },
    async search({ commit, state, dispatch }, queryString) {
      commit('setLoading', true);
      try {
        if (!state.tableConfig) {
          await dispatch('fetchTableConfig');
        }
        return await axios.get('api/supplier-orders/search' + (queryString || ''));
      } catch (e) {
      }
      commit('setLoading', false);
    },
    async fetch({ commit }, id) {
      return await axios.get(`api/supplier-orders/${id}`);
    },
    async search({ commit, state, dispatch }, queryString) {
      try {
        return await axios.get('api/supplier-orders/search' + (queryString || ''));
      } catch (e) {
      }
    },
    async create({ commit }, payLoad) {
      await axios.post('api/supplier-orders', payLoad);
    },
    async update({ commit }, payLoad) {
      await axios.put('api/supplier-orders', payLoad);
    },
    async send({ commit }, id) {
      return await axios.post(`api/send-supplier-orders/${id}`);
    },
    async cancel({ commit }, id) {
      return await axios.post(`api/cancel-supplier-orders/${id}`);
    },
    async undoCancel({ commit }, id) {
      return await axios.post(`api/undo-cancel-supplier-orders/${id}`);
    },
    async delete({ commit }, id) {
      await axios.delete(`api/supplier-orders/${id}`);
    },
    async excelExport({ commit }, { data, fileName, fileFormat }) {
      const excel = await axios({
        url: 'api/supplier-order-excel-export',
        method: 'POST',
        responseType: 'blob',
        data,
      });
      saveAs(excel, `${fileName.trim().split(' ').join('_') || 'SupplierOrders'}.${fileFormat.toLocaleLowerCase() || 'xlsx'}`);
    },
  },
};
